import type { PricesEntry } from '@cocoonspace/sdk-js/types/pricesEntry'
import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useSpacePrices } from '@cocoonspace/shared/hooks/cocoon-api'
import { useRouter } from 'next/router'
import { memo, useMemo, useState } from 'react'

import { BookingSidebarMultidateCalendar } from '~/domains/booking/components/molecules/booking-sidebar-multidate-calendar'
import { BookingSidebarMultidateFooter } from '~/domains/booking/components/molecules/booking-sidebar-multidate-footer'

interface DetailsSidebarMultidateBookingProps {
	space: Space
	maxDate: string
}

const DetailsSidebarMultidateBooking = ({
	space,
	maxDate,
}: DetailsSidebarMultidateBookingProps) => {
	const router = useRouter()

	const [bookingOptions, setBookingOptions] = useState<Date[]>(() => {
		if (!router.query.day) return []

		return Array.isArray(router.query.day)
			? router.query.day.map((day: string) => new Date(day))
			: [new Date(router.query.day)]
	})

	const { data: calendarPrices } = useSpacePrices(space.id, { to: maxDate })

	const daysPrices = useMemo<Record<string, PricesEntry>>(() => {
		if (!calendarPrices?.length) return {}

		return calendarPrices?.reduce((acc, item) => {
			return {
				...acc,
				[item.day]: item,
			}
		}, {})
	}, [calendarPrices])

	return (
		<div>
			<BookingSidebarMultidateCalendar
				bookingOptions={bookingOptions}
				calendarPrices={calendarPrices || []}
				daysPrices={daysPrices}
				maxDate={maxDate}
				onSelect={(days) => setBookingOptions(days || [])}
			/>

			<BookingSidebarMultidateFooter
				space={space}
				bookingOptions={bookingOptions}
				daysPrices={daysPrices}
				setBookingOptions={setBookingOptions}
			/>
		</div>
	)
}

export default memo(DetailsSidebarMultidateBooking)
